// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoomMonitoring
 */
export interface RoomMonitoring {
    /**
     * monitoring function name override
     */
    name?: string;
    /**
     * Path to LADS function to show in monitoring
     */
    path: string;
    /**
     * When the monitoring entry was added (set by the server)
     */
    createdAt?: Date;
}

/**
 * Check if a given object implements the RoomMonitoring interface.
 */
export function instanceOfRoomMonitoring(value: object): value is RoomMonitoring {
    if (!('path' in value) || value['path'] === undefined) return false;
    return true;
}

export function RoomMonitoringFromJSON(json: any): RoomMonitoring {
    return RoomMonitoringFromJSONTyped(json, false);
}

export function RoomMonitoringFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomMonitoring {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'path': json['path'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function RoomMonitoringToJSON(json: any): RoomMonitoring {
    return RoomMonitoringToJSONTyped(json, false);
}

export function RoomMonitoringToJSONTyped(value?: RoomMonitoring | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'path': value['path'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
    };
}

